export default __webpack_public_path__ + "svg/calendar/2027/6/septiembre.svg?23120882";